// extracted by mini-css-extract-plugin
export default {"loaded":"loaded-yGCtU","fadeIn":"fadeIn-9-k3s"};